import { Box, Stack, Tooltip, Typography } from '@mui/material';
import { useMemo } from 'react';
import { _ } from '/@/locale';

export interface CropDistributionItem {
    crop: string;
    percentage: number;
    fields: number;
    icon?: React.ReactElement;
    color: string;
    label: string;
    getChip?: (props: { text: string }) => React.ReactElement;
}

const CropDistributionBar = ({
    distribution,
    cropFilter,
}: {
    distribution: CropDistributionItem[];
    cropFilter?: string;
}) => {
    const filteredDistribution = useMemo(() => {
        if (!cropFilter) return distribution;
        return distribution.filter((item) => item.crop === cropFilter);
    }, [distribution, cropFilter]);

    return (
        <Stack spacing={1} sx={{ width: '100%' }}>
            {!cropFilter && (
                <Stack direction='row' alignItems='center' sx={{ width: '100%' }}>
                    {distribution.map((item, index) => (
                        <Tooltip
                            key={item.crop}
                            title={`${item.label}: ${_('{{count}} Lote', { count: item.fields })}`}
                            arrow
                            placement='top'
                        >
                            <Box
                                sx={[
                                    {
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        height: 12,
                                        width: `${item.percentage}%`,
                                        backgroundColor: item.color,

                                        color: 'white',
                                        fontSize: '0.75rem',
                                        fontWeight: 'bold',
                                        position: 'relative',
                                    },
                                    index === 0 && {
                                        borderRadius: '8px 0 0 8px;',
                                    },
                                    index === distribution.length - 1 && {
                                        borderRadius: '0 8px 8px 0',
                                    },
                                    distribution.length === 1 && {
                                        borderRadius: '8px 8px 8px 8px',
                                    },
                                    distribution.length === 2 &&
                                        (distribution[0]?.percentage || 0) < 1 && {
                                            borderRadius: '8px 8px 8px 8px',
                                        },
                                ]}
                            />
                        </Tooltip>
                    ))}
                </Stack>
            )}
            <Stack direction='row' spacing={1}>
                {filteredDistribution.map((item, index) => (
                    <Stack key={item.crop}>
                        {item.getChip && (
                            <Tooltip
                                title={
                                    cropFilter ? '' : `${item.label}: ${_('{{count}} Lote', { count: item.fields })}`
                                }
                                arrow
                                placement='top'
                            >
                                <Box>{item.getChip({ text: `${item.percentage}%` })}</Box>
                            </Tooltip>
                        )}
                        {cropFilter && (
                            <Typography variant='body1' color='primary'>
                                {_('{{count}} Lote', { count: item.fields })}
                            </Typography>
                        )}
                    </Stack>
                ))}
            </Stack>
        </Stack>
    );
};

export default CropDistributionBar;
